import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Modal,
  IconButton,
  Card,
} from "@mui/material";
import { Search, Eye, X } from "lucide-react";
import { Loading } from "./loading";
import { log_url } from "../api/urls";
import { TableComponent } from "./table";
import { useFetchWithPagination } from "../hooks/useFetchWithPagination";
import ExportToExcel from "./ExportToExcel";

const LogDetail = () => {
  const [selectedLog, setSelectedLog] = useState(null); // Track the selected log for modal
  const [open, setOpen] = useState(false); // Modal state
  const [filterModalOpen, setFilterModalOpen] = useState(false); // Modal state for the filter

  const [search, setSearch] = useState("");

  const { data, pagination, loading } = useFetchWithPagination(
    log_url + `${search ? `?search=${search}` : ""}`
  );
  const [expLoading, setExpLoading] = useState(false);
  const handleOpen = (log) => {
    setSelectedLog(log);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedLog(null);
  };

  const handleFilterModalClose = () => {
    setFilterModalOpen(false); // Close filter modal
  };

  if (loading) {
    return <Loading />;
  }
  const columns = [
    {
      headerName: "User",
      field: "username",
    },
    {
      headerName: "Module",
      field: "module_lable",
    },
    {
      headerName: "Action",
      field: "action",
    },
    {
      headerName: "Timestamp",
      field: "created_date",
    },
    {
      headerName: "IP",
      field: "remote_ip_address",
    },
    {
      headerName: "Actions",
      field: "check5",
      renderCell: (params) => (
        <IconButton onClick={() => handleOpen(params.row)}>
          <Eye />
        </IconButton>
      ),
    },
  ];
  return (
    <Box sx={{ p: 2 }}>
      <Card sx={{ padding: "20px" }} elevation={0}>
        <Box sx={{ display: "flex", justifyContent: "end", gap: "10px" }}>
          <ExportToExcel
            loading={expLoading}
            setLoading={setExpLoading}
            api_url={log_url}
            file_name={"logs_list"}
          />
          <TextField
            placeholder="Search"
            size="small"
            variant="outlined"
            sx={{
              width: "200px",
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: "1px solid",
                borderColor: "divider",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              sx: {
                bgcolor: "background.default",
              },
            }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Box sx={{ padding: "10px" }} />
        <TableComponent
          columns={columns}
          rows={data.data?.results || []}
          loading={data.loading}
        />
        <Box sx={{ padding: "10px" }} />
        {pagination}
      </Card>
      {/* Modal for log details */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "#ffffff",
            height: 400,
            p: 5,
            borderRadius: "8px",
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Log Details
          </Typography>
          {selectedLog && (
            <>
              <Typography>
                <strong>Username:</strong> {selectedLog.username || "N/A"}
              </Typography>
              <Typography>
                <strong>Module Label:</strong>{" "}
                {selectedLog.module_lable || "N/A"}
              </Typography>
              <Typography>
                <strong>Action:</strong> {selectedLog.action || "N/A"}
              </Typography>
              <Typography>
                <strong>Created Date:</strong>{" "}
                {selectedLog.created_date || "N/A"}
              </Typography>
              <Typography>
                <strong>Remote IP:</strong>{" "}
                {selectedLog.remote_ip_address || "N/A"}
              </Typography>
            </>
          )}
          <Box mt={2} textAlign="center">
            <IconButton
              onClick={handleClose}
              sx={{ position: "absolute", top: 10, right: 10 }}
            >
              <X size={50} color="#000000" />
            </IconButton>
          </Box>
        </Box>
      </Modal>

      {/* Filter Modal */}
      <Modal open={filterModalOpen} onClose={handleFilterModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            height: 400,
            bgcolor: "#ffffff",
            p: 4,
            borderRadius: "8px",
            display: "relative", // Ensure positioning context for the icon button
          }}
        >
          <Typography variant="h6" component="h2" gutterBottom>
            Filter Modal
          </Typography>

          <Box
            sx={{
              position: "absolute",
              top: 10, // Adjust as needed for spacing from top
              right: 10, // Adjust as needed for spacing from right
            }}
          >
            <IconButton onClick={handleFilterModalClose}>
              <X size={50} color="#000000" />
            </IconButton>
          </Box>

          <Typography></Typography>
          <Box mt={2} textAlign="center">
            {/* Additional content */}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default LogDetail;
